var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  y: 0.5,
  fill: "#E6EFE3",
  rx: 12
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#refresh_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#56893E",
  d: "m27.41 15.91-4.83-4.83c-.37-.37-.88-.58-1.41-.58H14c-1.1 0-1.99.9-1.99 2l-.01 16c0 1.1.89 2 1.99 2H26c1.1 0 2-.9 2-2V17.33c0-.53-.21-1.04-.59-1.42ZM20 26.5c-1.65 0-3.19-.81-4.12-2.17a.75.75 0 0 1 .19-1.04c.34-.24.81-.15 1.04.19.65.95 1.73 1.52 2.88 1.52 1.93 0 3.5-1.57 3.5-3.5a3.495 3.495 0 0 0-6.6-1.61l1.61 1.61H15c-.28 0-.5-.22-.5-.5v-3.5l1.3 1.3a4.98 4.98 0 0 1 4.2-2.3c2.76 0 5 2.24 5 5s-2.24 5-5 5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "refresh_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8.5h24v24H8z"
})))));
export default SvgRefresh;